import { useState } from 'react'
import { Ban } from 'lucide-react'

import { Button } from '@/common/ui/button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@/common/ui/dialog'
import { Label } from '@/common/ui/label'
import { Textarea } from '@/common/ui/textarea'

interface BanRoomDialogProps {
	open: boolean
	onOpenChange: (open: boolean) => void
	onConfirm: (reason: string) => void
	displayName: string
	isLoading?: boolean
}

export function BanRoomDialog({
	open,
	onOpenChange,
	onConfirm,
	displayName,
	isLoading = false,
}: BanRoomDialogProps) {
	const [reason, setReason] = useState('')

	const handleConfirm = () => {
		if (!reason.trim()) return
		onConfirm(reason.trim())
	}

	const handleOpenChange = (newOpen: boolean) => {
		if (!newOpen) {
			setReason('')
		}
		onOpenChange(newOpen)
	}

	return (
		<Dialog open={open} onOpenChange={handleOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle className="flex items-center gap-2">
						<Ban className="h-5 w-5 text-destructive" />
						ระงับห้องแชท
					</DialogTitle>
					<DialogDescription>
						คุณต้องการระงับห้องแชทของ{' '}
						<span className="font-medium text-foreground">{displayName}</span>{' '}
						หรือไม่? ห้องแชทนี้จะถูกซ่อนจากรายการแชทหลัก
					</DialogDescription>
				</DialogHeader>
				<div className="space-y-2 py-2">
					<Label htmlFor="ban-reason">
						เหตุผลในการระงับ <span className="text-destructive">*</span>
					</Label>
					<Textarea
						id="ban-reason"
						placeholder="กรุณาระบุเหตุผล เช่น ส่งข้อความสแปม, ใช้ภาษาไม่เหมาะสม..."
						value={reason}
						onChange={(e) => setReason(e.target.value)}
						className="min-h-[100px] resize-none"
						disabled={isLoading}
					/>
				</div>
				<DialogFooter>
					<Button
						variant="outline"
						onClick={() => handleOpenChange(false)}
						disabled={isLoading}
					>
						ยกเลิก
					</Button>
					<Button
						variant="destructive"
						onClick={handleConfirm}
						disabled={isLoading || !reason.trim()}
					>
						{isLoading ? 'กำลังดำเนินการ...' : 'ยืนยันการระงับ'}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
